import React from 'react';
import { FlatButton } from 'nrcs-design-system';
import { mdiArrowLeft } from '@mdi/js';
import { observer } from 'mobx-react';
import { DelineateWatershedInputStateVM } from '../DelineateWatershedInput/DelineateWatershedInputStateVM';

const UndoButtonComponent = (props: IUndoButtonComponentProps) => {
  const { activityViewModel, textButton } = props;

  if (!activityViewModel) {
    return null;
  }
  return !textButton ? (
    <FlatButton
      aria-label="Back"
      iconOnly={mdiArrowLeft}
      disabled={activityViewModel.jobExecuting}
      onClick={() => {
        activityViewModel!.undo();
        activityViewModel.createSnapShot();
      }}
      className="usa-button"
    >
      Back
    </FlatButton>
  ) : (
    <button
      disabled={activityViewModel.jobExecuting}
      onClick={() => {
        activityViewModel!.undo();
        activityViewModel.createSnapShot();
      }}
      className="usa-button"
    >
      Back
    </button>
  );
};

export const UndoButton = observer(UndoButtonComponent);

// Interfaces
interface IUndoButtonComponentProps {
  activityViewModel: DelineateWatershedInputStateVM;
  textButton?: boolean;
}
